import { useEffect, useRef } from "react";

const useClickOutSide = (handler: () => void) => {
	let domNode = useRef<HTMLDivElement>(null);
	const maybeHandler = (event: any) => {
		if (domNode.current && !domNode.current.contains(event.target)) {
			handler();
		}
	};
	useEffect(() => {
		document.addEventListener("mousedown", maybeHandler);

		return () => {
			document.removeEventListener("mousedown", maybeHandler);
		};
	});

	return domNode;
};

export default useClickOutSide;
